const LoginRoute = {
  path: "/login",
  name: "login",
  component: () => import("@/views/login/index.vue"),
};

const IndexRoute = {
  path: "",
  name: "basic",
  component: () => import("@/layout/Layout.vue"),
  redirect: "/index",
  children: [
    {
      path: "/index",
      name: "BasicIndex",
      component: () => import("@/views/index/index.vue"),
      meta: {
        id: "home",
        componentName: "home",
        keepAlive: true,
        name: "首页",
      },
    },
  ],
};

export default [LoginRoute, IndexRoute];
